export default "__VITE_ASSET__DD7W400d__"